import { Platform, StyleSheet, View } from 'react-native';

import { Text } from '@/components/ui';
import { useTheme } from '@/theme';

export function Marquee({ items }: { items: string[] }) {
  const theme = useTheme();
  const doubled = [...items, ...items];

  return (
    <View style={[styles.outer, { borderColor: theme.colors.rule }]}>
      <View
        style={[
          styles.track,
          Platform.OS === 'web'
            ? ({ animation: 'zk-marquee 30s linear infinite' } as any)
            : null,
        ]}
      >
        {doubled.map((it, i) => (
          <View key={`${it}-${i}`} style={styles.item}>
            <Text
              style={{
                fontFamily: theme.fontFamily.display,
                fontSize: 64,
                lineHeight: 72,
                color: theme.colors.fg,
              }}
            >
              {it}
            </Text>
            <Text
              style={{
                fontFamily: theme.fontFamily.displayItalic,
                fontStyle: 'italic',
                fontSize: 64,
                lineHeight: 72,
                color: theme.colors.accent,
                paddingHorizontal: 24,
              }}
            >
              ·
            </Text>
          </View>
        ))}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  outer: {
    paddingVertical: 32,
    borderTopWidth: 1,
    borderBottomWidth: 1,
    overflow: 'hidden',
  },
  track: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '200%',
  },
  item: {
    flexDirection: 'row',
    alignItems: 'center',
  },
});
